export enum AUDITINFO_STATE {
  WAIT_SUBMIT = 0,
  WAIT_AUDIT = 1,
  REJECT = 9,
  PASS = 5,
}
export enum AUDITINFO_STATE_LOG {
  PROCESS_FEE_EDIT = 11,
  WORKPROCESSEDIT = 10,
  REJECT = 9,
  CONSENT = 5,
  START = 4,
  CANCEL = 3,
  DESTORY = 2,
  SUBMIT = 1,
}

/**
 * 工作流程状态枚举
 *
 * @enum {number}
 */
export enum WORK_PROCESS_GROUP {
  /**
   * 进行中状态，值为2
   */
  PROCESSING = 2,

  /**
   * 已完成状态，值为3
   */
  COMPLETED = 3,

  /**
   * 提前完成状态，值为4
   */
  EARLY_COMPLETED = 4,

  /**
   * 逾期完成状态，值为5
   */
  OVERDUE_COMPLETED = 5,

  /**
   * 逾期状态，值为6
   */
  OVERDUE = 6,

  /**
   * 严重逾期状态，值为7
   */
  SEVERE_OVERDUE = 7,

  /**
   * 未完成状态，值为8
   */
  UNFINISHED = 8,

  /**
   * 待进行状态，值为9
   */
  WAIT_PROCESS = 9,
}

export enum WORK_PROCESS_STATUS {
  /**
   * 全部 0
   */
  ALL = 0,
  /**
   * 未完成 1
   */
  UNFINISHED = 1,
  /**
   * 已完成 2
   */
  FINISHED = 2,
}
export enum WROK_PROCESS_DATE_STATUS {
  /**
   * 全部 0
   */
  ALL = 0,
  /**
   * 未设置日期 2
   */
  UNSETTING = 2,
  /**
   * 未逾期 3
   */
  UNOVERDUE = 3,
  /**
   * 逾期 4
   */
  OVERDUE = 4,
}

export enum WORK_PROCESS_GROUP_STATUS {
  /**
   * 全部 0
   */
  ALL = 0,
  /**
   * 未完成 1
   */
  UNFINISHED = 1,
  /**
   * 已完成 2
   */
  FINISHED = 2,
}
export enum WROK_PROCESS_GROUP_DATE_STATUS {
  /**
   * 全部 0
   */
  ALL = 0,
  /**
   * 未设置日期 2
   */
  UNSETTING = 2,
  /**
   * 未逾期 3
   */
  UNOVERDUE = 3,
  /**
   * 逾期 4
   */
  OVERDUE = 4,
}

export enum RECOVER_AUDIT_STATE {
  /**
   * @description 待审核 1
   */
  WAIT_AUDIT = 1,
  /**
   * @description 审核通过 5
   */
  PASS = 5,
  /**
   * @description 审核未通过 9
   */
  REJECT = 9,
}
export type FEEAUDITSTATeNameMap = Record<keyof typeof AUDITINFO_STATE, string>;
export default {};

export enum MittEventKey {
  TAGCLOSE = 'tag-close',
  TAGCLOSERES = 'tag-close-res',
  TAGRELOAD = 'tag-reload',
}

export enum NODE_GROUP {
  DEFAULT = 1,
  AUDIT = 2,
}

export enum FEE_BUSINESS_SOURCE {
  PRODUCTION = 2,
  EDITION = 12,
  BILL = 8,
}

export enum TAB_MODULE {
  /**
   * @description 版单
   */
  EDITION = 12,
}
